import { LoadablePaint } from '@confluence/loadable';

export const DatabaseContainerLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DatabaseContainer" */ './DatabaseContainer.tsx'))
			.DatabaseContainer,
});
